
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-examples/single/[id]",
      function () {
        return require("private-next-pages/ad-examples/single/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ad-examples/single/[id]"])
      });
    }
  